import { find, findAll } from "../utils/dom"
import axios from "axios";
import Tooltip from "../DesignSystem/Tooltip";


const PageAgendaCultural = () => {
	const page = find("[js-page='agenda-cultural']");
	if (!page) return;


	const BASE_URL = window.location.origin;
	const BASE_STATIC = find('[js-base-static]').getAttribute('js-base-static');


	async function load_dados() {
		return await axios.get(`${BASE_URL}/api/programacao/`).then((response) => {
			const dados = response.data;
			return dados;
		}).catch((error) => {
			console.log(`Oppss! ${error}`);
			return;
		})
	}



	/** Variavel com as funcionalidades respectivas ao Calendário utilizando o HelloWeek */
	const $Calendario = {
		/**
		 * Função init
		 * Descrição: Função inicializadora da biblioteca HelloWeek.
		 * @param {object} _arrayDatas 
		 * @returns 
		 */
		init: (_arrayDatas) => {
			return new HelloWeek({
				selector: '.calendar',
				lang: 'pt',
				langFolder: './langs/',
				format: 'DD/MM/YYYY',
				todayHighlight: true,
				daysHighlight: _arrayDatas,
				nav: false,
				beforeCreateDay: (node) => {
					node.attributes.jsDataday = node.date
					return {
						...node,
						element: node
					};
				},
			});
		},
		/**
		 * Função: reset
		 * Descrição: Esta função reseta o calendário com dados filtrados, atualizados e etc..
		 * @param {*} _calendario 
		 * @param {object} _arrayDatas 
		 */
		reset: (_calendario, _arrayDatas) => {
			_calendario.reset({
				selector: '.calendar',
				lang: 'pt',
				langFolder: './langs/',
				format: 'DD/MM/YYYY',
				daysHighlight: _arrayDatas,
				nav: false,
				beforeCreateDay: (node) => {
					node.attributes.jsDataday = node.date
					return {
						...node,
						element: node
					};
				},
			})
		}
	}


	const $AgendaCultural = {
		ListCards: find('[js-list-card-agenda-cultural]'),
		ListCardsExposicoes: find('[js-list-card-exposicoes]'),
		DataListCards: find('[js-lista-card-agenda-data]'),
		SelectAtividadesCulturais: find('[js-select-atividades-culturais]'),
		updateAgenda: (_calendario, _value, _dados) => {
			const tipo = _value;

			let dadosFiltrados = _dados['eventos'];

			if (tipo != "") {
				dadosFiltrados = _dados['eventos'].filter((e) => {
					if (e['tipo'] == tipo) return e;
				});
			}

			const arrayDatas = [];
			for (let evento of dadosFiltrados) {
				const data_fim = evento['data_fim'] ?? undefined;
				const data_inicio = evento['data_hora_inicio'].split('T')[0];
				let data = [];

				if (data_fim != undefined && eventoValido(evento['tipo'])) {
					data = gerarIntervaloData(data_inicio, data_fim);


					for (let i of data) {
						arrayDatas.push({
							days: [i],
							title: evento['titulo'],
						})
					}

				} else if (eventoValido(evento['tipo'])) {
					data.push(data_inicio);

					arrayDatas.push({
						days: data,
						title: evento['titulo'],
					})
				}
			}

			$Calendario.reset(_calendario, arrayDatas);

			const diasDestacados = findAll('.is-highlight');
			for (let dia of diasDestacados) {
				dia.classList.remove('is-highlight');
			}
			arrayDatas.forEach((item) => {
				const day = item.days[0];
				find(`[jsdataday='${day}']`)?.classList.add('is-highlight');
			});


			handleEventAddBolinha(tipo);
		}
	}


	const $dados = {
		dados: load_dados(),
	}


	/**
	 * Função: isSegundaFeira
	 * 
	 * Descrição: Esta função recebe uma data específica como parâmetro e retorna true se ela for uma segunda-feira, caso contrário, retorna false
	 * @param {Date} data 
	 * @returns {Boolean}
	 */
	function isSegundaFeira(data) {
		return (data.getDay() == 1)
	}


	/**
	 * Função: gerarIntervaloData
	 * 
	 * Descrição: Esta função recebe duas strings de data (_dataInicio e _dataFim) no formato YYYY-MM-DD. E retorna um objeto de string no formato YYYY-MM-DD contendo as datas do intervalo entre _dataInicio e _dataFim.
	 * @param {string} _dataInicio [ data inicial no formato YYYY-MM-DD ]
	 * @param {string} _dataFim [ data final no formato YYYY-MM-DD ]
	 * @returns {object}
	 */
	function gerarIntervaloData(_dataInicio, _dataFim) {

		const dataHoje = new Date();
		let dataAtual = new Date(`${_dataInicio}T${dataHoje.toLocaleTimeString()}`);
		const dataFim = new Date(_dataFim);
		const data = []

		while (dataAtual <= dataFim) {

			if (!isSegundaFeira(dataAtual)) {
				const ano = dataAtual.getFullYear();
				const mes = (dataAtual.getMonth() + 1).toString().padStart(2, '0');
				const dia = dataAtual.getDate().toString().padStart(2, '0');
				data.push(`${ano}-${mes}-${dia}`);
			}
			dataAtual.setDate(dataAtual.getDate() + 1);
		}


		return data;
	}


	/**
	 * Função: textMes
	 * 
	 * Descrição: Esta função retorna o título do mês completo em Português BR.
	 * @param {string} mes
	 * @returns {string | null}
	 */
	function textMes(mes) {
		switch (mes) {
			case '01':
			case 1:
				return 'Janeiro';
				break;
			case '02':
			case 2:
				return 'Fevereiro';
				break;
			case '03':
			case 3:
				return 'Março';
				break;
			case '04':
			case 4:
				return 'Abril';
				break;
			case '05':
			case 5:
				return 'Maio';
				break;
			case '06':
			case 6:
				return 'Junho';
				break;
			case '07':
			case 7:
				return 'Julho';
				break;
			case '08':
			case 8:
				return 'Agosto';
				break;
			case '09':
			case 9:
				return 'Setembro';
				break;
			case '10':
			case 10:
				return 'Outubro';
				break;
			case '11':
			case 11:
				return 'Novembro';
				break;
			case '12':
			case 12:
				return 'Dezembro';
				break;
		}

		return;
	}

	/**
	 * Função: getColor
	 * 
	 * Descrição: Esta função auxiliar retorna o código hexadecimal da cor correspondente ao tipo de evento, utilizado nas bolinhas indicativas.
	 * @param {string} tipo
	 * @returns {string} 
	 */
	function getColor(tipo) {
		switch (tipo) {
			case 'concertos':
				return '#C8AC5C';
				break;
			case 'literatura':
				return '#4A5F4C';
				break;
			case 'historia_do_brasil':
				return '#926D37'
				break;
			case 'relacoes_amorosas':
				return '#1B1A18'
				break;
			case 'cinema':
				return '#D7932E'
				break;
			case 'exposicoes':
				return '#2CA18B'
				break;
		}
	}


	function getImg(tipo) {
		switch (tipo) {
			case 'literatura':
				return `${BASE_STATIC}images/icones_agenda_cultural/literatura.svg`;
				break;
			case 'historia_do_brasil':
				return `${BASE_STATIC}images/icones_agenda_cultural/historia-brasil.svg`;
				break;
			case 'relacoes_amorosas':
				return `${BASE_STATIC}images/icones_agenda_cultural/relacoes-amorosas.svg`;
				break;
			case 'cinema':
				return `${BASE_STATIC}images/icones_agenda_cultural/cinema.svg`;
				break;
			case 'concertos':
				return `${BASE_STATIC}images/icones_agenda_cultural/musica.svg`;
				break;
			case 'fechado':
				return `${BASE_STATIC}images/icones_agenda_cultural/fechado.svg`;
				break;
		}
	}


	/**
	 * Função: eventoValido
	 * 
	 * Descrição: Esta função verifica os tipos de eventos validos para exibição no calendário.
	 * @param {string} eventoTipo 
	 * @returns {boolean}
	 */
	function eventoValido(eventoTipo) {
		if (eventoTipo != "cha_com_apl" && eventoTipo != "encontros_com_wisnik" && eventoTipo != "exposicoes") {
			return true;
		}
		return false;
	}

	/** Extrai data e horário do ISO retornado pela API (fuso America/Sao_Paulo). */
	function extrairDataHoraEvento(dataHoraInicio) {
		const [dataISO, horaISO] = dataHoraInicio.split('T');
		const [, hh = '00', mm = '00'] = horaISO.match(/^(\d{2}):(\d{2})/) ?? [];

		return {
			data_evento: dataISO.split('-'),
			hh,
			mm,
		};
	}



	/** Layout dos demais cards */
	function criarCard(value, data_evento, hh, mm, urlLink, buttonIngressos, popUpIngresso) {
		const card = document.createElement("div");
		card.className = "bg-complementary-dark-20 flex flex-col justify-between";

		/* ================= HEADER ================= */
		const header = document.createElement("div");
		header.className = "p-[1.5rem_2rem] xl2:p-[1rem_1.5rem]";

		const grid = document.createElement("div");
		grid.className =
			"grid grid-cols-[256px_1fr] xl2:grid-cols-[200px_1fr] sm:grid-cols-1 gap-[2rem] md:gap-[20px]";

		/* ===== Coluna esquerda ===== */
		const leftCol = document.createElement("div");

		const figure = document.createElement("figure");
		figure.className = "w-full h-auto";

		const img = document.createElement("img");
		img.className = "w-full h-auto";
		img.src = value.imagem_card_apresentacao;
		img.alt = "";

		figure.appendChild(img);

		const subtitleWrapper = document.createElement("div");

		const subtitle = document.createElement("p");
		subtitle.className =
			"text-paragraph-6 text-complementary-dark xl2:text-[10px] md:text-[0.75rem]";
		subtitle.textContent = value.subtitulo ?? "";

		subtitleWrapper.appendChild(subtitle);

		leftCol.appendChild(figure);
		leftCol.appendChild(subtitleWrapper);

		/* ===== Coluna direita ===== */
		const rightCol = document.createElement("div");
		rightCol.className = "self-center";

		const title = document.createElement("h4");
		title.className =
			"text-headline-5 text-primary-dark xl2:text-[26px] md:text-[1.25rem] !font-extrabold";
		title.innerHTML = value.titulo;

		const divider = document.createElement("span");
		divider.className =
			"h-[1px] w-full bg-primary-dark my-[1rem] xl2:my-[.8rem] md:my-[10px] inline-flex";

		const date = document.createElement("p");
		date.className =
			"text-headline-7 text-primary-dark !uppercase xl2:text-[1.125rem] text-limit-3";
		date.textContent = `${data_evento[2]} de ${textMes(
			data_evento[1]
		)} - ${hh}h${mm}`;

		rightCol.appendChild(title);
		rightCol.appendChild(divider);
		rightCol.appendChild(date);

		grid.appendChild(leftCol);
		grid.appendChild(rightCol);
		header.appendChild(grid);

		/* ================= FOOTER ================= */
		const footer = document.createElement("div");
		footer.className =
			`grid ${popUpIngresso != "" ? 'grid-cols-2' : buttonIngressos != null ? 'grid-cols-2' : 'grid-cols-1'} border-t-[1px] border-neutral-100/20 border-solid`;

		const leftFooter = document.createElement("span");
		leftFooter.className =
			"inline-flex h-full w-full border-r-[1px] border-neutral-100/20 border-solid";

		const rightFooter = document.createElement("span");
		rightFooter.className =
			"inline-flex h-full w-full border-r-[1px] border-neutral-100/20 border-solid";

		const link = document.createElement("a");
		link.href = urlLink;
		link.className =
			"Button text-caps-4 xl2:!text-[13px] w-full h-full";
		link.style.border = "none";
		link.textContent = "Saiba mais";
		link.setAttribute("bg-tertiary", "");

		leftFooter.appendChild(link);

		footer.appendChild(leftFooter);

		// Caso buttonIngressos já seja um elemento DOM
		if (buttonIngressos != null || popUpIngresso != "") {
			const linkIngressos = document.createElement("a");
			if (buttonIngressos != null) {
				linkIngressos.href = buttonIngressos;
			}
			linkIngressos.className =
				"Button text-caps-4 xl2:!text-[13px] w-full h-full";
			linkIngressos.style.border = "none";
			linkIngressos.textContent = "Ingressos";
			linkIngressos.setAttribute("bg-tertiary", "");
			linkIngressos.setAttribute("target", "_blank");
			linkIngressos.setAttribute("target", "noopener noreferrer");
			if (popUpIngresso != "") {
				linkIngressos.setAttribute("data-tippy-content", popUpIngresso);
			}

			rightFooter.appendChild(linkIngressos);
			footer.appendChild(rightFooter);
		}


		/* ================= FINAL ================= */
		card.appendChild(header);
		card.appendChild(footer);

		return card;
	}


	/** 
	 * Função: construct_card
	 * 
	 * Descrição: Esta função constrói os cards que estão sendo apresentados ao lado direito do contéudo da página Agenda Cultural.
	 * @param {object} dados - Variável que contém os dados carregados da API. 
	 * @returns 
	 * 
	 */
	function construct_card(dados) {
		$AgendaCultural.ListCards.innerHTML = '';
		let Cards = new Array();
		dados.forEach((value) => {


			const { data_evento, hh, mm } = extrairDataHoraEvento(value['data_hora_inicio']);

			let urlLink = '';


			switch (value['tipo']) {
				case 'exposicoes':
					urlLink = `${BASE_URL}/exposicoes/${value['id']}`;
					break;
				case 'cha_com_apl':
					urlLink = `${BASE_URL}/cha-com-apl/${value['slug']}`;
					break;
				case 'literatura':
					urlLink = `${BASE_URL}/eventos-literatura/${value['slug']}`;
					break;
				case 'historia_do_brasil':
					urlLink = `${BASE_URL}/historia-do-brasil/${value['slug']}`;
					break;
				case 'relacoes_amorosas':
					urlLink = `${BASE_URL}/relacoes-amorosas/${value['slug']}`;
					break;
				default:
					urlLink = `${BASE_URL}/${value['tipo']}/${value['slug']}`
					break;
			}

			let buttonIngressos = '';
			if (value['link_ingressos'] != null) {
				buttonIngressos = `
					<a href="${value['link_ingressos']}" target="_blank" bg-tertiary class="Button text-caps-4 xl2:!text-[13px]" style="border: none;">
						Ingressos
					</a>
				`
			} else {
				buttonIngressos = `
					<button data-tippy-content="${value['pop_up_ingresso']}" bg-tertiary class="Button text-caps-4 xl2:!text-[13px]" style="border: none;">
						Ingressos
					</button>
				`
			}

			const card = criarCard(value, data_evento, hh, mm, urlLink, value['link_ingressos'], value['pop_up_ingresso']);

			Cards.push(card);
		})

		Cards.forEach(card => {
			$AgendaCultural.ListCards.appendChild(card);
		});

		Tooltip();
	}



	/** Layout dos card de Exposição */
	function criarCardExposicao(value, data_evento, hh, mm, urlLink, buttonIngressos, popUpIngresso) {
		const card = document.createElement("div");
		card.className = "bg-complementary-dark-20 flex flex-col justify-between";

		/* ================= HEADER ================= */
		const header = document.createElement("div");
		header.className = "p-[1.5rem_2rem] xl2:p-[1rem_1.5rem]";

		const grid = document.createElement("div");
		grid.className = "grid grid-cols-[1fr_1fr] md:grid-cols-1 gap-[8px]";

		/* ===== Coluna esquerda ===== */
		const leftCol = document.createElement("div");

		const figure = document.createElement("figure");
		figure.className = "w-full h-auto md:max-h-[303px]";

		const img = document.createElement("img");
		img.className = "w-auto max-w-[200px] h-auto max-h-[120px]";
		img.src = value.imagem_card_apresentacao;
		img.alt = value.titulo ?? "";
		img.loading = "lazy";

		figure.appendChild(img);

		const leftContent = document.createElement("div"); // vazio (comentado no HTML)

		leftCol.appendChild(figure);
		leftCol.appendChild(leftContent);

		/* ===== Coluna direita ===== */
		const rightCol = document.createElement("div");
		rightCol.className = "self-center";

		const titulo = document.createElement("p");
		titulo.className =
			"text-headline-8 text-primary-dark !uppercase !text-[1rem] text-limit-3";
		titulo.textContent = value.titulo;

		const subtitulo = document.createElement("p");
		subtitulo.className =
			"text-paragraph-6 text-complementary-dark xl2:text-[10px] md:text-[0.75rem]";
		subtitulo.textContent = value.subtitulo ?? "";

		rightCol.appendChild(titulo);
		rightCol.appendChild(subtitulo);

		grid.appendChild(leftCol);
		grid.appendChild(rightCol);

		header.appendChild(grid);

		/* ================= FOOTER ================= */
		const footer = document.createElement("div");
		footer.className =
			"grid grid-cols-2 border-t-[1px] border-neutral-100/20 border-solid";

		const leftFooter = document.createElement("span");
		leftFooter.className =
			"inline-flex h-full w-full border-r-[1px] border-neutral-100/20 border-solid";

		const rightFooter = document.createElement("span");
		rightFooter.className =
			"inline-flex h-full w-full border-r-[1px] border-neutral-100/20 border-solid";

		const link = document.createElement("a");
		link.href = urlLink;
		link.className =
			"Button text-caps-4 xl2:!text-[13px] w-full h-full";
		link.style.border = "none";
		link.textContent = "Saiba mais";
		link.setAttribute("bg-tertiary", "");
		link.setAttribute("aria-label", `Saiba mais sobre ${value.titulo}`);

		leftFooter.appendChild(link);

		footer.appendChild(leftFooter);


		// Caso buttonIngressos já seja um elemento DOM
		if (buttonIngressos != null || popUpIngresso != "") {
			const linkIngressos = document.createElement("a");
			if (buttonIngressos != null) {
				linkIngressos.href = buttonIngressos;
			}
			linkIngressos.className =
				"Button text-caps-4 xl2:!text-[13px] w-full h-full";
			linkIngressos.style.border = "none";
			linkIngressos.textContent = "Ingressos";
			linkIngressos.setAttribute("bg-tertiary", "");
			linkIngressos.setAttribute("target", "_blank");
			linkIngressos.setAttribute("target", "noopener noreferrer");
			if (popUpIngresso != "") {
				linkIngressos.setAttribute("data-tippy-content", popUpIngresso);
			}

			rightFooter.appendChild(linkIngressos);
			footer.appendChild(rightFooter);
		}

		/* ================= FINAL ================= */
		card.appendChild(header);
		card.appendChild(footer);

		return card;
	}


	/** 
	 * Função: construct_card_exposicao
	 * 
	 * Descrição: Esta função constrói os cards de exposições que estão sendo apresentados ao lado direito do contéudo da página Agenda Cultural.
	 * @param {object} dados - Variável que contém os dados carregados da API. 
	 * @returns 
	 * 
	 */

	function construct_card_exposicao(dados) {
		if ($AgendaCultural.ListCardsExposicoes.classList.contains('invisible')) {
			$AgendaCultural.ListCardsExposicoes.classList.remove(
				'invisible',
				'overflow-hidden',
				'h-0'
			);
		}


		$AgendaCultural.ListCardsExposicoes.innerHTML = '';

		let cards = new Array();

		dados.forEach((value) => {

			const { data_evento, hh, mm } = extrairDataHoraEvento(value['data_hora_inicio']);
			let urlLink = `${BASE_URL}/exposicoes/${value['id']}`;

			let buttonIngressos = '';
			if (value['link_ingressos'] != null) {
				buttonIngressos = `
					<a href="${value['link_ingressos']}" target="_blank" bg-tertiary class="Button text-caps-4 xl2:!text-[13px]" style="border: none;">
						Ingressos
					</a>
				`
			} else {
				buttonIngressos = `
					<button data-tippy-content="${value['pop_up_ingresso']}" bg-tertiary class="Button text-caps-4 xl2:!text-[13px]" style="border: none;">
						Ingressos
					</button>
				`
			}


			cards.push(criarCardExposicao(value, data_evento, hh, mm, urlLink, value['link_ingressos'], value['pop_up_ingresso']))
		})

		cards.forEach(card => {
			$AgendaCultural.ListCardsExposicoes.appendChild(card);
		});


		Tooltip();
	}


	function convertDatatoStringData(_data) {
		return `${_data.getFullYear()}-${(_data.getMonth() + 1 < 10) ? '0' + (_data.getMonth() + 1) : _data.getMonth() + 1}-${(_data.getDate() < 10) ? '0' + _data.getDate() : _data.getDate()}`
	}


	async function handleEventLoad(_calendario) {
		const dataHoje = new Date();

		const stringData = `${dataHoje.getFullYear()}-${(dataHoje.getMonth() + 1 < 10) ? '0' + (dataHoje.getMonth() + 1) : dataHoje.getMonth() + 1}-${(dataHoje.getDate() < 10) ? '0' + dataHoje.getDate() : dataHoje.getDate()}`;
		const dados = await $dados.dados;

		const datasFechado = dados['datas_fechado'];


		$AgendaCultural.DataListCards.innerHTML = `${dataHoje.getDate()} de ${textMes(dataHoje.getMonth() + 1)}, ${dataHoje.getFullYear()}`
		const dadosFiltrados = dados['eventos'].filter((e) => {
			if (e['data_hora_inicio'].split('T')[0] == stringData && eventoValido(e['tipo']) && !isSegundaFeira(dataHoje) && !datasFechado.includes(stringData)) {
				return e;
			}
		})

		const dadosFiltradosExposicoes = dados['eventos'].filter((e) => {
			if (e['data_fim']) {
				const dataInicio = new Date(e['data_hora_inicio'].split('T')[0]);
				const dataFim = new Date(e['data_fim'].split('T')[0]);
				const dataHoje = new Date(stringData);

				return dataHoje >= dataInicio && dataHoje <= dataFim && e['tipo'] == 'exposicoes';
			}
		})

		if (dadosFiltrados.length > 0) {
			construct_card(dadosFiltrados);
		}
		else {
			$AgendaCultural.ListCards.innerHTML = `
				<p class="text-headline-7 text-primary-dark !uppercase xl2:text-[1.125rem] text-limit-3">
					Não tem nenhum evento marcado para esta data.
				</p>	
			`
		}

		if (dadosFiltradosExposicoes.length > 0) {
			construct_card_exposicao(dadosFiltradosExposicoes);
		} else {
			$AgendaCultural.ListCardsExposicoes.innerHTML = "";
		}


		$AgendaCultural.SelectAtividadesCulturais.addEventListener("change", (e) => {
			$AgendaCultural.updateAgenda(_calendario, e.target.value, dados)
			handleDiaFechado()
		})

		if ($AgendaCultural.SelectAtividadesCulturais.value != "") {
			$AgendaCultural.updateAgenda(_calendario, $AgendaCultural.SelectAtividadesCulturais.value, dados)
			handleDiaFechado()
		}


	}


	function handleEventClick() {
		const event = findAll("[jsdataday]")

		event.forEach((item) => {
			item.addEventListener("click", async (e) => {
				const value = e.target.getAttribute('jsdataday');

				const valueData = value.split('-')

				$AgendaCultural.DataListCards.innerHTML = `${valueData[2]} de ${textMes(valueData[1])}, ${valueData[0]}`

				const dados = await $dados.dados;

				const datasFechado = dados['datas_fechado'];
				const dataCorrente = new Date();
				const dataCorrenteHoje = new Date(`${value}T${dataCorrente.toLocaleTimeString()}`);

				const dadosFiltrados = dados['eventos'].filter((e) => {

					if (!isSegundaFeira(dataCorrenteHoje) && !datasFechado.includes(convertDatatoStringData(dataCorrenteHoje))) {
						if (e['data_fim']) {
							const dataInicio = new Date(e['data_hora_inicio'].split('T')[0]);
							const dataFim = new Date(e['data_fim'].split('T')[0]);
							const dataHoje = new Date(value);


							return dataHoje >= dataInicio && dataHoje <= dataFim && eventoValido(e['tipo']);

						} else {
							return (e['data_hora_inicio'].split('T')[0] == value && eventoValido(e['tipo']));
						}
					}

				});


				const dadosFiltradosExposicoes = dados['eventos'].filter((e) => {
					if (e['data_fim']) {
						const dataInicio = new Date(e['data_hora_inicio'].split('T')[0]);
						const dataFim = new Date(e['data_fim'].split('T')[0]);
						const dataHoje = new Date(value);

						return dataHoje >= dataInicio && dataHoje <= dataFim && e['tipo'] == 'exposicoes';
					}
				})



				if (dadosFiltrados.length > 0) {
					construct_card(dadosFiltrados);
				}
				else {
					$AgendaCultural.ListCards.innerHTML = `
						<p class="text-headline-7 text-primary-dark !uppercase xl2:text-[1.125rem] text-limit-3">
							Não tem nenhum evento marcado para esta data.
						</p>	
					`
				}



				if (dadosFiltradosExposicoes.length > 0) {
					construct_card_exposicao(dadosFiltradosExposicoes);
				} else {
					$AgendaCultural.ListCardsExposicoes.innerHTML = ''
				}

			})
		})

	}

	async function handleDiaFechado() {
		const event = findAll("[jsdataday]");
		const dados = await $dados.dados;
		const datasFechado = dados['datas_fechado'];

		const dataAgora = new Date();
		event.forEach(async (item) => {
			const data = item.getAttribute('jsdataday');
			const DataDay = new Date(`${data}T${dataAgora.toLocaleTimeString()}`)


			if (!isSegundaFeira(DataDay) && !datasFechado.includes(data)) return;


			/** Criando uma tag figure no DOM */
			const figure = document.createElement('figure');
			Object.assign(figure.style, {
				position: 'absolute',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				width: '100%',
				height: '100%',
				pointerEvents: 'none',
				padding: '8px',
			});

			/** Criando uma tag span no DOM para adicionar o número da data */
			const span = document.createElement('span');
			Object.assign(span.style, {
				position: 'relative',
				display: 'flex',
				zIndex: 1,
				color: 'white',
				textShadow: `2px 0 #000, -2px 0 #000, 0 2px #000, 0 -2px #000,
						1px 1px #000, -1px -1px #000, 1px -1px #000, -1px 1px #000`,
				pointerEvents: 'none',
			})
			span.textContent = item.textContent;
			item.innerHTML = '';


			/** Criando uma tag img no DOM para adicionar o icone 'fechado' e exibir no bloco dos dias que estiverem fechados. */
			const img = document.createElement('img');
			img.src = getImg('fechado');
			img.alt = 'Icone Evento';
			Object.assign(img.style, {
				width: '100%',
				height: 'auto',
				pointerEvents: 'none',
				filter: 'drop-shadow(0 0 0 white) drop-shadow(0 0 2px white) drop-shadow(0 0 4px white)',
				opacity: '.3',
			})

			figure.appendChild(img);
			item.appendChild(span);
			item.appendChild(figure);

			/** Para editar a cor, ver no custom.css */
			item.classList.add("is-closed");


			/*	const div = document.createElement('div');
				Object.assign(div.style,{
					position: 'absolute',
					display: 'flex',
					justifyContent: "center",
					gap: '.25rem',
					width: '90%',
					bottom: "2px",
					background: "#A4303F",
					color: "white",
					borderRadius: "4px",
					pointerEvents: "none",
				})
	
				div.textContent = 'Fechado';
	
				item.appendChild(div);*/



		})
	}

	async function handleEventAddBolinha(isFiltro = '') {
		const event = findAll("[jsdataday]");
		const dados = await $dados.dados;
		const datasFechado = dados['datas_fechado'];


		const dataAgora = new Date()

		event.forEach(async (item) => {
			const data = item.getAttribute('jsdataday');
			const DataDay = new Date(`${data}T${dataAgora.toLocaleTimeString()}`)


			if (isSegundaFeira(DataDay) || datasFechado.includes(data)) return;



			/*const div = document.createElement('div');
			Object.assign(div.style,{
				position: 'absolute',
				display: 'flex',
				gap: '.25rem',
				alignItems: 'center',
				justifyContent: 'center',
				width: '100%',
				bottom: ".25rem",
				pointerEvents: "none",
			})*/



			let dadosFiltrados;
			if (isFiltro != '') {
				dadosFiltrados = dados['eventos'].filter((e) => {
					if (e['tipo'] == isFiltro && eventoValido(e['tipo'])) return e;
				})
			} else {
				dadosFiltrados = dados['eventos']
			}




			const result = await dadosFiltrados.filter((e) => {
				const dataHoje = new Date(`${data}T${dataAgora.toLocaleTimeString()}`);
				const dataHojeString = convertDatatoStringData(dataHoje)


				// Essa verificação é pro caso do evento ser do tipo exposicoes
				/*
				if(e['data_fim']){
					const dataInicio = new Date(e['data_hora_inicio']);
					const dataFim = new Date(e['data_fim']);
					
					return dataHoje >= dataInicio && dataHoje <= dataFim && eventoValido(e['tipo'] && !isSegundaFeira(dataHoje) && !datasFechado.includes(dataHojeString));
	
				}else{
					return (e['data_hora_inicio'].split('T')[0] == data && eventoValido(e['tipo']) && !isSegundaFeira(dataHoje) && !datasFechado.includes(dataHojeString));
				}*/

				return (e['data_hora_inicio'].split('T')[0] == data && eventoValido(e['tipo']) && !isSegundaFeira(dataHoje) && !datasFechado.includes(dataHojeString));
			});




			if (result.length > 0) {
				item.classList.add("relative");

				const figure = document.createElement('figure');
				Object.assign(figure.style, {
					position: 'absolute',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					width: '100%',
					height: '100%',
					pointerEvents: 'none',
					padding: '8px',
				});

				const span = document.createElement('span');
				Object.assign(span.style, {
					position: 'relative',
					display: 'flex',
					zIndex: 1,
					color: 'white',
					textShadow: `2px 0 #000, -2px 0 #000, 0 2px #000, 0 -2px #000,
						1px 1px #000, -1px -1px #000, 1px -1px #000, -1px 1px #000`,
					pointerEvents: 'none',
				})
				span.textContent = item.textContent;
				item.innerHTML = '';



				const img = document.createElement('img');
				img.src = getImg(result[0]['tipo']);
				img.alt = 'Icone Evento';
				Object.assign(img.style, {
					width: '100%',
					height: 'auto',
					pointerEvents: 'none',
					filter: 'drop-shadow(0 0 0 white) drop-shadow(0 0 2px white) drop-shadow(0 0 4px white)',
				})

				figure.appendChild(img);
				item.appendChild(span);
				item.appendChild(figure);
				item.style.setProperty('background', getColor(result[0]['tipo']), 'important')


			}





		})
	}



	async function init() {

		const dados = await $dados.dados;
		//console.log(dados)
		const datasFechado = dados['datas_fechado'];

		const arrayDatas = [];

		for (let evento of dados['eventos']) {

			const data_fim = evento['data_fim'] ?? undefined;
			const data_inicio = evento['data_hora_inicio'].split('T')[0];
			let data = [];

			if (data_fim != undefined && eventoValido(evento['tipo'])) {
				data = gerarIntervaloData(data_inicio, data_fim);
				const dataHoje = new Date();


				for (let i of data) {
					const dataAtual = new Date(`${i}T${dataHoje.toLocaleTimeString()}`);
					const dataString = convertDatatoStringData(dataAtual);

					if (!isSegundaFeira(dataAtual) && !datasFechado.includes(dataString)) {
						arrayDatas.push({
							days: [i],
							title: evento['titulo'],
						})
					}
				}

			} else if (eventoValido(evento['tipo'])) {
				data.push(data_inicio);

				arrayDatas.push({
					days: data,
					title: evento['titulo'],
				})
			}


		}



		const calendario = $Calendario.init(arrayDatas);


		find(".calendar .next").addEventListener("click", () => {
			calendario.next();
			handleEventClick();
			handleEventAddBolinha();
			handleDiaFechado()

			handleEventLoad(calendario);

		})

		find(".calendar .prev").addEventListener("click", () => {
			calendario.prev();
			handleEventClick();
			handleEventAddBolinha();
			handleDiaFechado()

			handleEventLoad(calendario);
		})


		let semafaroLoad = true;
		const observer = new MutationObserver((mutationList) => {
			for (let mutation of mutationList) {
				if (mutation.type === 'childList' || mutation.type === 'characterData') {
					handleEventClick();

					if (semafaroLoad) {
						handleEventLoad(calendario);
						handleEventAddBolinha();
						handleDiaFechado();
						semafaroLoad = false;
					}
				}
			}
		})

		observer.observe(find(".calendar"), {
			childList: true,
			subtree: true,
			characterData: true
		})


	}

	init();




}

export default PageAgendaCultural()